import { createGlobalStyle } from "styled-components";
import { connect } from "react-redux";

import DubaiBoldEot from "./assets/fonts/DubaiW23-Bold.eot";
import DubaiBoldTtf from "./assets/fonts/DubaiW23-Bold.ttf";
import DubaiBoldWoff from "./assets/fonts/DubaiW23-Bold.woff";
import DubaiBoldWoff2 from "./assets/fonts/DubaiW23-Bold.woff2";

import DubaiLightEot from "./assets/fonts/DubaiW23-Light.eot";
import DubaiLightTtf from "./assets/fonts/DubaiW23-Light.ttf";
import DubaiLightWoff from "./assets/fonts/DubaiW23-Light.woff";
import DubaiLightWoff2 from "./assets/fonts/DubaiW23-Light.woff2";

import DubaiMediumEot from "./assets/fonts/DubaiW23-Medium.eot";
import DubaiMediumTtf from "./assets/fonts/DubaiW23-Medium.ttf";
import DubaiMediumWoff from "./assets/fonts/DubaiW23-Medium.woff";
import DubaiMediumWoff2 from "./assets/fonts/DubaiW23-Medium.woff2";

import DubaiRegularEot from "./assets/fonts/DubaiW23-Regular.eot";
import DubaiRegularTtf from "./assets/fonts/DubaiW23-Regular.ttf";
import DubaiRegularWoff from "./assets/fonts/DubaiW23-Regular.woff";
import DubaiRegularWoff2 from "./assets/fonts/DubaiW23-Regular.woff2";


const GlobalStyle = createGlobalStyle`
@font-face {
  font-family: "Dubai-bold";
  src: url(${DubaiBoldEot});
  src: url("./assets/fonts/DubaiW23-Bold.eot?#iefix")
      format("embedded-opentype"),
    url(${DubaiBoldTtf}) format("truetype"),
    url(${DubaiBoldWoff}) format("woff"),
    url(${DubaiBoldWoff2}) format("woff2");
  font-weight: bold;
  font-style: normal;
}
@font-face {
  font-family: "Dubai-light";
  src: url(${DubaiLightEot});
src: url("${DubaiLightEot}?#iefix")
      format("embedded-opentype"),
    url(${DubaiLightTtf}) format("truetype"),
    url(${DubaiLightWoff}) format("woff"),
    url(${DubaiLightWoff2}) format("woff2");
  font-weight: lighter;
  font-style: normal;
}
@font-face {
  font-family: "Dubai-medium";
  src: url(${DubaiMediumEot});
  src: url("${DubaiMediumEot}?#iefix")
      format("embedded-opentype"),
    url(${DubaiMediumTtf}) format("truetype"),
    url(${DubaiMediumWoff}) format("woff"),
    url(${DubaiMediumWoff2}) format("woff2");
  font-weight: 200;
  font-style: normal;
}
@font-face {
  font-family: "Dubai-regular";
  src: url(${DubaiRegularEot});
src: url("${DubaiRegularEot}?#iefix")
      format("embedded-opentype"),
    url(${DubaiRegularTtf}) format("truetype"),
    url(${DubaiRegularWoff}) format("woff"),
    url(${DubaiRegularWoff2}) format("woff2");
  font-weight: normal;
  font-style: normal;
}

.graph {
  text-align: center;
}

.entity-sector-graph,
.channel-entity-graph,
.kpi-entity-graph {
  text-align: center;
  overflow: hidden;
  max-height: 100vh;
}

.tooltip {
  z-index:3;
  background: #87a8d8;
  border: 0;
  border-radius: 12px;
  font-size: 12px;
  height: 150px;
  width: 175px;
  box-sizing: border-box;
  padding: 10px 20px 5px;
  pointer-events: none;
  position: absolute;
  text-align: right;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  filter: drop-shadow(7px 7px 25px rgba(9, 26, 45, 0.749));

}
.tooltip-title {
  font-family: "dubai-medium";
  color: black;
  font-size: 20px;
  margin: 10px 0;
  display: inline-block;

}
.tooltip-name {
  font-family: "Dubai-light";
  color: black;
}
.smallgraph-marking {
  font-family: "Dubai-light";
  font-size: 9px;
  fill: black;
}

body {
  font-family: "Dubai-regular";
  font-size: 12px;
  line-height: 18px;
  color: #c1c1c1;
  padding: 0;
  margin: 0;
  overflow: ${props => (props.stopScroll ? "hidden" : "auto")};
}

::-webkit-scrollbar {
  display: none;
}
body {
  overflow: -moz-scrollbars-none;
}
body {
  -ms-overflow-style: none;
}
.textfield {
  position: relative;
  display: inline-block;
  line-height: 1.5;
  overflow: hidden;
  width: 75%;
  text-align: right;
  margin-top: 20px;
}

/* Input, Textarea */
.textfield > input,
.textfield > textarea {
  text-align: right;
  display: block;
  box-sizing: border-box;
  margin: 0;
  border: none;
  border-top: solid 27px transparent;
  border-bottom: solid 2px #455ee5;
  padding: 0 0 4px;
  width: 100%;
  height: inherit;
  color: #c1c1c1;
  background-color: transparent;
  box-shadow: none; /* Firefox */
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
  transition: border-bottom 0.2s, background-color 0.2s;
}

/* Span */
.textfield > input + span,
.textfield > textarea + span {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: block;
  box-sizing: border-box;
  padding: 7px 0 0;
  color: #c1c1c1;
  font-size: 15px;
  line-height: 18px;
  pointer-events: none;
  transition: color 0.2s, font-size 0.2s, line-height 0.2s;
}

/* Underline */
.textfield > input + span::after,
.textfield > textarea + span::after {
  content: "";
  position: absolute;
  left: 0;
  bottom: 0;
  display: block;
  width: 100%;
  height: 2px;
  background-color: #ffffff;
  transform-origin: bottom center;
  transform: scaleX(0);
  transition: transform 0.2s;
}

/* Hover */
.textfield > input:hover,
.textfield > textarea:hover {
  border-bottom-color: #455ee5;
}

/* Placeholder-shown */
.textfield > input:not(:focus):placeholder-shown + span,
.textfield > textarea:not(:focus):placeholder-shown + span {
  font-size: inherit;
  line-height: 56px;
}

/* Focus */
.textfield > input:focus,
.textfield > textarea:focus {
  outline: none;
}

.textfield > input:focus + span,
.textfield > textarea:focus + span {
  color: #c1c1c1;
}

.textfield > input:focus + span::before,
.textfield > textarea:focus + span::before {
  opacity: 0.12;
}

.textfield > input:focus + span::after,
.textfield > textarea:focus + span::after {
  transform: scale(1);
}

/* Disabled */
.textfield > input:disabled,
.textfield > textarea:disabled {
  color: gray;
}

.textfield > input:disabled + span,
.textfield > textarea:disabled + span {
  color: gray;
}

/* Faster transition in Safari for less noticable fractional font-size issue */
@media not all and (min-resolution: 0.001dpcm) {
  @supports (-webkit-appearance: none) {
    .textfield > input,
    .textfield > input + span,
    .textfield > input + span::after,
    .textfield > textarea,
    .textfield > textarea + span,
    .textfield > textarea + span::after {
      transition-duration: 0.1s;
    }
  }
}

@media (max-width: 575px) {
  .graph {
    margin: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
  }
}

/*== Slider ==*/
.slider .rc-slider-rail {
  border: 1px solid rgb(46, 112, 116);
  background-color: transparent;
  height: 17.5px;
  border-radius: 33px;
}

.slider .rc-slider-track {
  background-color: rgb(46, 112, 116);
  height: 17.5px;
  transition: width 1s ease 0s, left 1s ease 0s;
  left: 25%;
  width: 25%;
}

.slider .rc-slider-handle {
  height: 17.5px;
  width: 17.5px;
  margin-top: 0px;
  background-color: rgb(46, 112, 116);
  transition: left 1s ease 0s;
  border: 1px solid rgb(255, 255, 255);
}

.slider .rc-slider-mark-text {
  font-size: 10px;
  margin-top: 8px;
}

.slider .rc-slider-handle-2 {
  margin-left: -14px;
}

@media (min-width: 1800px) {
  .slider .rc-slider-rail {
    border: 2px solid rgb(46, 112, 116);
    height: 23px;
  }

  .slider .rc-slider-track {
    height: 23px;
  }

  .slider .rc-slider-handle {
    height: 23px;
    width: 23px;
    border: 2px solid rgb(255, 255, 255);
  }
  .slider .rc-slider-mark-text {
    font-size: 18px;
    margin-top: 18px;
  }
}

@media (max-width: 575px) {
  .slider .rc-slider-rail {
    border: 2px solid rgb(46, 112, 116);
    height: 11px;
  }

  .slider .rc-slider-track {
    height: 11px;
  }

  .slider .rc-slider-handle {
    height: 11px;
    width: 11px;
    border: 2px solid rgb(255, 255, 255);
  }
  .slider .rc-slider-mark-text {
    font-size: 11px;
    margin-top: 5px;
  }
  .slider .rc-slider-handle-2 {
    margin-left: -10px;
  }
}

.overlays circle{
  cursor: pointer;
}

textarea {resize: none}


`;

const mapStateToProps = state => ({
  stopScroll: !state.app.scroll
});

export default connect(mapStateToProps)(GlobalStyle);
